import type {
  TopicChannelProvider,
  TopicReportFeedbackKind,
  TopicReportFeedbackReason,
} from "@app/analytics/types";
import { sendEvent } from "@app/utils/tracking/Tracker";

export const topicReportView = sendEvent<{
  channelProvider: TopicChannelProvider;
}>("topic_report_view", {
  statsig: { valueKey: "channelProvider" },
});

export const submitTopicReportFeedback = sendEvent<{
  feedback: TopicReportFeedbackKind;
  reasons: TopicReportFeedbackReason[];
}>("topic_report_feedback");
